import helper from '@main/externals/bss-package-helper/js/helper';
export var commonFunctions = {
    createListOfAllowedParams: function () {
        return new Set([
            'country',
            'brand',
            'language',
            'modelId',
            'carId',
            'exteriorColourId',
            'upholsteryId',
            'quoteId',
            'financeQuoteId',
            'packs',
            'dealer',
            'options',
            'totalPrice',
            'accessories',
            'promotions',
            'suffix',
            'katashiki',
            'elementType',
            'vehicle',
            'financial',
            'offline',
            'dealerCode',
            'tradeInValue',
            'dealerPhoneNumber',
            'dealerName',
            'apiSource',
            'productType',
            'availableFromDate',
            'availableToDate',
        ]);
    },
    prepareConfigData: function (tempConfigData, allowedParams) {
        return Object.keys(tempConfigData).reduce(function (config, param) {
            var paramName = helper.prepareParamName(param);
            if (allowedParams.has(paramName)) {
                config[paramName] = helper.prepareParamValue(tempConfigData[param]);
            }
            return config;
        }, {});
    },
    prepareData: function (elRenderer, tempConfigData) {
        var _a, _b;
        if (elRenderer.prepareData) {
            return elRenderer.prepareData(tempConfigData);
        }
        else {
            var allowedParams = this.createListOfAllowedParams();
            var configData = tempConfigData
                ? this.prepareConfigData(tempConfigData, allowedParams)
                : {};
            if (tempConfigData === null || tempConfigData === void 0 ? void 0 : tempConfigData.PSLS) {
                var PSLS = tempConfigData.PSLS;
                if ('Suffix' in PSLS) {
                    var _c = PSLS.Suffix, Code = _c.Code, Katashiki = _c.Katashiki;
                    configData.suffix = Code;
                    configData.katashiki = Katashiki;
                }
                if ('LocalConfiguration' in PSLS) {
                    configData.localCode = PSLS.LocalConfiguration.Code;
                }
            }
            if (tempConfigData.parameters) {
                configData.parameters = tempConfigData.parameters;
            }
            if (typeof ((_a = tempConfigData.Parameters) === null || _a === void 0 ? void 0 : _a.FinanceProductType) !== 'undefined') {
                configData.financeProductType =
                    tempConfigData.Parameters.FinanceProductType;
            }
            if (typeof ((_b = tempConfigData.Parameters) === null || _b === void 0 ? void 0 : _b.FinanceQuoteID) !== 'undefined') {
                configData.quoteId = tempConfigData.Parameters.FinanceQuoteID;
            }
            if (tempConfigData.costs) {
                /**
                 * @desc Data passed to the BE, FE does not care about the data content.
                 * @example Can be found on FR NC Toyota.
                 * @type {Record<string, string>[]}
                 */
                configData.costs = JSON.stringify(tempConfigData.costs);
            }
            return configData;
        }
    },
    initLoader: function (containerSelector) {
        var containerSelectorId = this._extractIdSelector(containerSelector);
        document
            .getElementById(containerSelectorId)
            .classList.add('bss-entity-container');
        if (window.PreLoader) {
            if (containerSelector !== '#entity') {
                window.PreLoader.opts.containerId = containerSelectorId;
            }
            window.PreLoader.init();
        }
    },
    setQuoteIdInFQS: function (quoteId) {
        window.fqs.set({
            finance: quoteId,
        });
    },
    _extractIdSelector: function (selector) {
        return selector.substring(1);
    },
};
